module.exports = __webpack_public_path__ + "img/ico_vencedor_active.5fd0a7be.png";